import React, { useEffect, useRef, useState, useCallback } from 'react';
import meImg from '../team/me.jpg';
import neneImg from '../team/neneba.jpg';
import marieImg from '../team/marie.jpg';
import hamidImg from '../team/leuz.jpg';
import soumImg from '../team/soum.jpeg';

const TEAM = [
  {
    id: 1,
    name: 'Babacar',
    role: 'Cofondateur & CTO',
    image: meImg,
    skills: ['React', 'Node.js', 'AWS'],
    color: '#FF7E5F'
  },
  {
    id: 2,
    name: 'Néné',
    role: 'Ingénieure Logicielle',
    image: neneImg,
    skills: ['Python', 'Django', 'PostgreSQL'],
    color: '#61DAFB'
  },
  {
    id: 3,
    name: 'Marie',
    role: 'Cofondatrice & CTO',
    image: marieImg,
    skills: ['React Native', 'Firebase', 'UI/UX'],
    color: '#FF7E5F'
  },
  {
    id: 4,
    name: 'Faty',
    role: 'Ingénieure Logicielle',
    image: soumImg,
    skills: ['Java', 'Spring Boot', 'MySQL'],
    color: '#6C63FF'
  },
  {
    id: 5,
    name: 'Hamid',
    role: 'Infographiste',
    image: hamidImg,
    skills: ['Figma', 'Photoshop', 'After Effects'],
    color: '#FF6B6B'
  }
];

export default function Team() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState('left');
  const intervalRef = useRef(null);
  const cardRef = useRef(null);

  const totalSlides = TEAM.length;
  const visibleCount = 3;

  // Calculer les indices des cartes visibles
  const getVisibleCards = () => {
    const cards = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (currentIndex + i) % totalSlides;
      cards.push({ ...TEAM[index], displayIndex: i });
    }
    return cards;
  };

  // Utiliser useCallback pour mémoriser nextSlide
  const nextSlide = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setDirection('left');
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  }, [isAnimating, totalSlides]);

  const prevSlide = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setDirection('right');
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  }, [isAnimating, totalSlides]);

  // Auto-play avec nextSlide comme dépendance
  useEffect(() => {
    intervalRef.current = setInterval(nextSlide, 4000);
    return () => clearInterval(intervalRef.current);
  }, [nextSlide]);

  // Réinitialiser l'animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 600);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  const visibleCards = getVisibleCards();

  return (
      <section className="team" id="team">
        <div className="container">
          <div className="section-header">
            <h2>
              <span className="gradient-text">Notre Équipe</span>
            </h2>
            <p>Des experts passionnés prêts à innover</p>
          </div>

          <div className="team-slider-wrapper">
            <div className="team-slider-container">
              <button
                  className="slider-nav prev"
                  onClick={prevSlide}
                  aria-label="Précédent"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              <div className="team-slider-track">
                <div
                    className={`team-slider ${isAnimating ? `slide-${direction}` : ''}`}
                    ref={cardRef}
                >
                  {visibleCards.map((member) => (
                      <div
                          key={`${member.id}-${member.displayIndex}`}
                          className={`team-card team-card-${member.displayIndex}`}
                          style={{ '--card-color': member.color }}
                      >
                        <div className="team-card-inner">
                          <div className="team-image-wrapper">
                            <div className="team-image-ring">
                              <img
                                  src={member.image}
                                  alt={member.name}
                                  className="team-image"
                              />
                            </div>
                            <div className="tech-pulse" style={{ background: member.color }} />
                          </div>

                          <h3>{member.name}</h3>
                          <p className="team-role">{member.role}</p>

                          <div className="team-skills">
                            {member.skills.map((skill, idx) => (
                                <span key={idx} className="skill-tag">
                            <span className="skill-dot" style={{ background: member.color }} />
                                  {skill}
                          </span>
                            ))}
                          </div>

                          <div className="team-hover-overlay">
                            <div className="tech-lines">
                              <span className="line"></span>
                              <span className="line"></span>
                              <span className="line"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              </div>

              <button
                  className="slider-nav next"
                  onClick={nextSlide}
                  aria-label="Suivant"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>

            <div className="slider-indicators">
              {TEAM.map((_, index) => (
                  <button
                      key={index}
                      className={`indicator ${index === currentIndex ? 'active' : ''}`}
                      onClick={() => {
                        if (index > currentIndex) setDirection('left');
                        else if (index < currentIndex) setDirection('right');
                        setCurrentIndex(index);
                      }}
                      aria-label={`Voir ${TEAM[index].name}`}
                  />
              ))}
            </div>

            <div className="tech-bg-elements">
              <div className="tech-circle"></div>
              <div className="tech-circle"></div>
              <div className="tech-circle"></div>
            </div>
          </div>
        </div>
      </section>
  );
}